import React, { useState, useEffect } from 'react';

const AddCourse = () => {

    const [category_name, setcategory_name] = useState('');
    const [categories, setCategories] = useState([]);

    const [courseName, setCourseName] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');

    const [courses, setCourses] = useState([]);

    // Fetch Categories
    const fetchCategories = async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/category`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });

        const data = await res.json();
        setCategories(data);
    };

    // Fetch Courses
    const fetchCourses = async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/courses`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });

        const data = await res.json();
        setCourses(data);
    };

    useEffect(() => {
        fetchCategories();
        fetchCourses();
    }, []);

    const handleAddCourse = async (event) => {
        event.preventDefault();

        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/course/courses`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: JSON.stringify({
                category_name: category_name,
                course: courseName,
                description: description,
                price: price
            })
        });

        if (res.ok) {
            alert("Course Added Successfully");
            setcategory_name('');
            setCourseName('');
            setDescription('');
            setPrice('');
            fetchCourses(); // Refresh list
        } else {
            alert("Failed to add course");
        }
    };

    return (
        <div className="container mt-5">
            <h2>Add Course</h2>

            <form onSubmit={handleAddCourse}>
                <select
                    value={category_name}
                    onChange={(e) => setcategory_name(e.target.value)}
                >
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                        <option key={cat.id} value={cat.name}>
                            {cat.name}
                        </option>
                    ))}
                </select>

                <input
                    type="text"
                    placeholder="Course Name"
                    value={courseName}
                    onChange={(e) => setCourseName(e.target.value)}
                />

                <input
                    type="text"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />

                <input
                    type="number"
                    placeholder="Price"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                />

                <button type="submit">Add Course</button>
            </form>

            <h3 className="mt-4">Courses:</h3>
            <div>
                {courses.map((course) => (
                    <p key={course.id}>
                        {course.category_name} — {course.course} — {course.description} — ₹{course.price}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default AddCourse;
